import * as React from 'react';

import styles from './Link.css';

export interface ILinkProps extends React.HTMLProps<HTMLAnchorElement> {
  children: React.ReactNode;

  onClick?: (event: React.SyntheticEvent) => void;

  url: string;
  target?: string;
  title?: string;
  testId?: string;
}

export const Link: React.FC<ILinkProps> = props => {
  const { children, id, onClick, url, target, title, testId } = props;

  return (
    <a
      className={styles['element']}
      data-testid={testId}
      href={url}
      id={id}
      rel="noopener noreferrer"
      target={target && `_${target}`}
      title={title}
      onClick={onClick}
    >
      {children}
    </a>
  );
};
